<div [ngClass]="{'mobile': isMobile}" class="content">
  <div class="subtitle">
    <typography variant="mat-subtitle-2" weight="bold">{{ appStrings.paymentDetails_info }}</typography>
  </div>

  <form [formGroup]="paymentDetailsForm" class="payment-details-container" id="paymentDetailsContainer">
    @if (!leadId) {
      <div class="checkbox-container">
        @if (isCreditCardEligible) {
          <ds-checkbox class="checkbox" id="creditCardChecboxContainer" (change)="setCreditCardFieldDependencies()"
            [label]="appStrings.paymentDetails_credit_card" [control]="paymentDetailsForm.controls.creditCard" [isDisabled]="!canEdit || quoteSaveInProgress">
          </ds-checkbox>
        }
        @if (!isMobile && isCreditCardEligible) {
          <div class="vertical-divider">
            <ds-divider [vertical]="true"></ds-divider>
          </div>
        }
        <ds-checkbox class="checkbox" [label]="appStrings.paymentDetails_block_order" id="blockOrderCheckbox"
          [control]="paymentDetailsForm.controls.blockOrder" [isDisabled]="!canEdit || quoteSaveInProgress">
        </ds-checkbox>
      </div>
    }
    <ds-textfield id="paymentPurchaseOrderInput" [ngClass]="{'quarter-width fill-gap': !isMobile}" class="fill-width purchase-order" [label]="appStrings.paymentDetails_purchase_order"
      label_orientation="vertical-label" [isDisabled]="!canEdit || quoteSaveInProgress" [control]="paymentDetailsForm.controls.paymentPurchaseOrder" [maxLength]="fieldMaxLengths.purchaseOrder">
    </ds-textfield>
    @if (customerId) {
      <ds-select id="paymentPaymentTermsInput" [ngClass]="{'quarter-width fill-gap': !isMobile}" class="fill-width"
        [label]="appStrings.paymentDetails_payment_terms" label_orientation="vertical-label" isDisabled="true"
        [control]="paymentDetailsForm.controls.paymentPaymentTerms" [dropOptions]="paymentTermsList">
      </ds-select>
    }
    <div class="button-container">
      <ds-button size="medium" type="tertiary" variant="label-icon" [label]="appStrings.paymentDetails_attach_purchase_order_small" id="purchaseOrderBtn" icon="attach_file"
        (onClick)="openUploadAttachment(paymentDetailsForm.value.paymentPurchaseOrderId)"
        [isDisabled]="!paymentDetailsForm.value.paymentPurchaseOrderId || quoteSaveInProgress">
      </ds-button>
      @if (!attachmentsCount && !paymentDetailsForm.controls.creditCard.value) {
        <mat-error class="PO-att-error">
          {{ appStrings.paymentDetails_paymentPurchaseOrderMissing }}
        </mat-error>
      }
    </div>
  </form>

  @if (customerId) {
    <ds-divider></ds-divider>
  }

  @if (customerId) {
    <div>
      <mat-expansion-panel id="shippingInfoContainer" class="no-border nested-expansion-panel shipping-info-panel" [ngClass]="{'address-panel-with-info': !isMobile}">
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title [ngClass]="isMobile ? 'mobile-panel-title': 'panel-title'">
            <div class="title-row">
              <span class="title" id="shippingAddressTitle">
                {{ appStrings.paymentDetails_shipping_info }}
              </span>
              <span class="info" *appIsDesktop>
                <typography id="shippingAddressLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.invoice_shipToAddress }} </typography>
                <typography id="shippingAddress" variant="mat-body-1" weight="medium">
                  {{ getAddressDisplay(shippingAddress) }}
                </typography>
              </span>
              <span class="input" *appIsDesktop>
                <ds-checkbox id="shippingCheckbox" [label]="appStrings.paymentDetails_shipping_to_complete" (change)="updateShipToComplete()"
                  (click)="$event.stopPropagation()" [isDisabled]="!canEdit || quoteSaveInProgress" [control]="shippingDetailsForm.controls.shipToComplete">
                </ds-checkbox>
                <div class="vertical-divider">
                  <ds-divider [vertical]="true"></ds-divider>
                </div>
              </span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="shipping-info" id="shippingInfo">
          @if (shippingAddress.id) {
            <div class="vertical-label textfield ds fill-width disabled" [ngClass]="{'quarter-width fill-gap': !isMobile}">
              <mat-label class="label-text-field">{{ appStrings.paymentDetails_shipping_address }}</mat-label>
              <mat-form-field appearance="outline">
                <input id="shipppingAddressInput" matInput [value]="shippingAddress.name" disabled/>
              </mat-form-field>
            </div>
          }
          <div class="address-info" [ngClass]="{'three-quarters-width': !isMobile}">
            <div class="row">
              <typography id="shippingAddressLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.accounts_labelAddress }} </typography>
              <typography id="shippingAddress" variant="mat-body-1" weight="medium">
                {{ getAddressDisplay(shippingAddress) }}
              </typography>
            </div>
          </div>
          @if (!europeanCountry) {
            <ds-select id="carrier" class="fill-width" [ngClass]="{'quarter-width': !isMobile}"
              [label]="appStrings.quote_paymentDetailsCarrier" [dropOptions]="displayCarriersList" label_orientation="vertical-label"
              [control]="shippingDetailsForm.controls.carrier" [isDisabled]="!canEdit || quoteSaveInProgress" (selectionChange)="carrierChanged($event)">
            </ds-select>
          }
          @if (!hideAreaOrFinalDestination && !europeanCountry) {
            <div class="vertical-label textfield ds fill-width disabled" [ngClass]="{'quarter-width fill-gap': !isMobile}">
              <mat-label class="label-text-field">{{ appStrings.paymentDetails_shipping_area }}</mat-label>
              <mat-form-field appearance="outline">
                <input id="shippingAreaInput" matInput [value]="area" disabled/>
              </mat-form-field>
            </div>
          }
          @if (!hideAreaOrFinalDestination && !europeanCountry) {
            <ds-select id="finalDestination" class="fill-width" [ngClass]="{'quarter-width fill-gap': !isMobile}"
              [label]="appStrings.paymentDetails_finalDestination" [dropOptions]="countryList" label_orientation="vertical-label"
              [control]="shippingDetailsForm.controls.finalDestination" [isDisabled]="!canEdit || quoteSaveInProgress"
              (selectionChange)="markPaymentDetailsAsOutdated()">
            </ds-select>
          }
          <ds-textfield id="paymentCustomerReferenceInput" class="fill-width" [ngClass]="{'quarter-width fill-gap': !isMobile}"
            [label]="appStrings.quote_paymentDetailsCustomerReference" label_orientation="vertical-label" [isDisabled]="!canEdit || quoteSaveInProgress"
            [control]="shippingDetailsForm.controls.customerReference" [maxLength]="fieldMaxLengths.customerReference">
          </ds-textfield>
          <div class="checkbox-container" *appIsMobile>
            <ds-checkbox id="shippingCheckbox" [label]="appStrings.paymentDetails_shipping_to_complete" (change)="updateShipToComplete()"
              [isDisabled]="!canEdit || quoteSaveInProgress" [control]="shippingDetailsForm.controls.shipToComplete">
            </ds-checkbox>
          </div>
        </div>
      </mat-expansion-panel>
      <ds-divider></ds-divider>
      <mat-expansion-panel id="billingInfoContainer" class="no-border nested-expansion-panel billing-info-panel" [ngClass]="{'address-panel-with-info': !isMobile}">
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title [ngClass]="isMobile ? 'mobile-panel-title': 'panel-title'">
            <div class="title-row">
              <span class="title" id="billingAddressTitle">
                {{ appStrings.paymentDetails_billing_info }}
              </span>
              <span class="info" *appIsDesktop>
                <typography id="billingAddressLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_billing_address }} </typography>
                <typography id="billingAddress" variant="mat-body-1" weight="medium">
                  {{ getAddressDisplay(billingAddress) }}
                </typography>
              </span>
              <span class="input" *appIsDesktop>
                @if (countriesToDisplayDoNotEmail[countryCode]) {
                  <ds-checkbox id="billing_doNotEmail" (change)="setDoNotMailFieldDependencies()"
                    (click)="$event.stopPropagation()" [label]="appStrings.paymentDetails_do_not_email" [control]="billingDetailsForm.controls.doNotEmail"
                    [isDisabled]="!canEdit || quoteSaveInProgress">
                  </ds-checkbox>
                }
                <div class="vertical-divider">
                  <ds-divider [vertical]="true"></ds-divider>
                </div>
              </span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="billing-info" id="billingInfo">
          <ds-autocomplete id="billingAddressInput" class="fill-width" [ngClass]="{'quarter-width': !isMobile}"
            [options]="billingDetailsForm.controls.doNotEmail.value ? doNotMailBillingAddressesList : displayBillingAddressesList"
            [label]="appStrings.paymentDetails_billing_address" label_orientation="vertical-label" [control]="billingDetailsForm.controls.billingAddressInput"
            [isDisabled]="!canEdit || quoteSaveInProgress" (selectionChange)="setBillingAddressMobile($event)" fullFilter="true">
          </ds-autocomplete>
          <div class="address-info" [ngClass]="{'three-quarters-width': !isMobile}">
            <div class="row">
              <typography id="billingAddressLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.accounts_labelAddress }} </typography>
              <typography id="billingAddress" variant="mat-body-1" weight="medium">
                {{ getAddressDisplay(billingAddress) }}
              </typography>
            </div>
            @if (isMobile && countriesToDisplayDoNotEmail[countryCode]) {
              <ds-checkbox id="billing_doNotEmail" (change)="setDoNotMailFieldDependencies()"
                [label]="appStrings.paymentDetails_do_not_email" [control]="billingDetailsForm.controls.doNotEmail" [isDisabled]="!canEdit || quoteSaveInProgress">
              </ds-checkbox>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  }

  <ds-divider></ds-divider>

  <div id="totalsContainer" class="information totals" [ngClass]="{'full-width-totals' : !isMobile}">
    <div class="row one-item">
      <typography id="subtotalLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_summary_sub_total }} </typography>
      @if (!leadId) {
        <typography id="subtotal_name" variant="mat-body-1" weight="medium">
          {{ paymentSummary.subTotal | currency: currencySymbol }}
        </typography>
      }
      @if (leadId) {
        <typography id="subTotalForLead" variant="mat-body-1" weight="medium">
          {{ !paymentSummary.subTotal || hasTaxComputingError ? appStrings.notApplicable : paymentSummary.subTotal | currency: currencySymbol }}
        </typography>
      }
    </div>
    <div class="row two-columns two-items">
      @if (customerId) {
        <div class="column">
          <typography id="freightLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_summary_freight }} </typography>
          <typography [ngClass]="{'hidden': paymentDetailsOutdated}" id="freight_name" variant="mat-body-1" weight="medium">
            {{ hasTaxComputingError ? appStrings.notApplicable : paymentSummary.freightCost | currency: currencySymbol }}
          </typography>
          <typography [ngClass]="{'hidden': !paymentDetailsOutdated}" id="freight_name" variant="mat-body-1" weight="medium">
            {{ appStrings.quote_fieldIsOutdated }}
          </typography>
        </div>
      }
      @if (leadId) {
        <div class="column">
          <ds-textfield class="no-subscript" id="freightInput" [label]="appStrings.paymentDetails_summary_freight" label_orientation="vertical-label"
            [control]="taxDetailsForm.controls.freightInput" (onBlur)="setPaymentDetailsOutdated()" start_adornment_type="text" [start_adornment_value_text]="currencySymbol">
          </ds-textfield>
        </div>
      }
      @if (customerId) {
        <div class="column">
          <typography id="TaxRateLabel" class="label" variant="mat-caption-2" weight="regular"> {{ taxRateNaming }}: </typography>
          @if (!hasTaxComputingError) {
            <typography [ngClass]="{'hidden': paymentDetailsOutdated}" id="tax_value" variant="mat-body-1" weight="medium">
              {{ paymentSummary.tax | currency: currencySymbol }}
            </typography>
          }
          <typography [ngClass]="{'hidden': !paymentDetailsOutdated}" id="tax_outdated" variant="mat-body-1" weight="medium">
            {{ appStrings.quote_fieldIsOutdated }}
          </typography>
          @if (hasTaxComputingError) {
            <typography class="record red" [ngClass]="{'hidden': paymentDetailsOutdated}" id="summaryTaxWithError" variant="mat-body-1" weight="medium">
              {{ appStrings.paymentDetails_unableToCalculateTax }}
            </typography>
          }
        </div>
      }
      @if (leadId) {
        <div class="column">
          <ds-textfield class="no-subscript" id="taxInput" [label]="taxRateNaming" label_orientation="vertical-label"
            [control]="taxDetailsForm.controls.taxRateInput" (onBlur)="setPaymentDetailsOutdated()" end_adornment_type="text" end_adornment_value_text="%">
          </ds-textfield>
        </div>
      }
    </div>
    <div class="row two-columns two-items">
      <div class="column">
        <typography id="weightLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_summary_tax_weight }} </typography>
        <typography id="weight_name" variant="mat-body-1" weight="medium" [hidden]="!paymentSummary.totalWeight">
          {{ hasTaxComputingError ? appStrings.notApplicable : paymentSummary.totalWeight | number : '1.2-2' }} {{ weightSymbol }}
        </typography>
      </div>
      <div class="column">
        <typography id="grandTotalLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_summary_grand_total }} </typography>
        <typography id="grand_total" variant="mat-body-1" weight="medium" [ngClass]="{'hidden': paymentDetailsOutdated}">
          {{ hasTaxComputingError ? appStrings.notApplicable : paymentSummary.grandTotal | currency: currencySymbol}}
        </typography>
        <typography id="grand_total_outdated" variant="mat-body-1" weight="medium" [ngClass]="{'hidden': !paymentDetailsOutdated}">
          {{ appStrings.quote_fieldIsOutdated }}
        </typography>
      </div>
    </div>
  </div>
</div>